// extracted by mini-css-extract-plugin
module.exports = {"footer":"FileParser_footer__2p8-n"};